import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Table } from "antd";
import { useIntl } from "react-intl";

import LoadError from "../loadError";
import LoadSkeleton from "../loadSkeleton";

import "./index.css";

function LoadTable({
  what,
  values,
  columns,
  pageSize,
  className,
  emptyText,
  tableProps,
  onLoadValues,
  selectedRows,
  setSelectedRows,
  getCheckboxProps,
  onRowDoubleClick,
}) {
  const intl = useIntl();
  const onSelectChange = useCallback(
    (selectedRowKeys) => {
      setSelectedRows(selectedRowKeys);
    },
    [setSelectedRows]
  );

  const [rowSelection, setRowSelection] = useState();
  useEffect(() => {
    setRowSelection(
      selectedRows && {
        getCheckboxProps,
        onChange: onSelectChange,
        selectedRowKeys: selectedRows,
      }
    );
  }, [onSelectChange, selectedRows, getCheckboxProps]);

  return (
    <Row gutter={[0, 20]}>
      <Col>
        {values ? (
          values === "e" ? (
            <LoadError
              onClick={onLoadValues}
              message={intl.formatMessage(
                {
                  id: "messages.loadErrorEntity",
                  defaultMessage: "Při načítání {what} nastala chyba.",
                },
                { what }
              )}
            />
          ) : (
            <Table
              {...tableProps}
              columns={columns}
              dataSource={values}
              locale={{ emptyText }}
              rowSelection={rowSelection}
              pagination={{ pageSize: pageSize || 10 }}
              className={`${className || ""} load-table`}
              onRow={(record) => ({
                onDoubleClick: () =>
                  onRowDoubleClick && onRowDoubleClick(record),
              })}
            />
          )
        ) : (
          <LoadSkeleton />
        )}
      </Col>
    </Row>
  );
}

export default LoadTable;
